// extracted by mini-css-extract-plugin
export default {"mobile-wrap":"Mobile_mobile-wrap__LOqmO","root":"Mobile_root__LO639","App":"Mobile_App__NrCkA"};